import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { Location } from '@angular/common';
import { scaleInAnimation } from 'src/@fury/animations/scale-in.animation';
import { fadeInRightAnimation } from 'src/@fury/animations/fade-in-right.animation';
import { fadeInUpAnimation } from 'src/@fury/animations/fade-in-up.animation';

@Component({
  selector: 'fury-plan-type-add-edit',
  templateUrl: './plan-type-add-edit.component.html',
  styleUrls: ['./plan-type-add-edit.component.scss'],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation]
})
export class PlanTypeAddEditComponent implements OnInit {
  planpropertytype!: FormGroup;
  planTypeId: any;
  constructor(
    private apiservice: ApiService,
    public location: Location,
    private activatedroute: ActivatedRoute,
  ) {
    this.activatedroute.params.subscribe((res: any) => {
      this.planTypeId = res?.id;
      if (this.planTypeId) this.getDetails();
    });
   }

  ngOnInit() {
    this.planpropertytype = new FormGroup({
      title: new FormControl('', Validators.required)
    });
  }

  add() {
    if (this.planpropertytype.valid) {
      if(this.planTypeId) {
        this.apiservice.patch(`admin/plan/property-type/update-property-type/${this.planTypeId}`, this.planpropertytype.value).subscribe((res: any) => {
          if (res) {
            this.location.back();
          }
        }, err => {
          this.apiservice.alert('Somthing went wrong', 'error');
        });
      } else {
        this.apiservice.post('admin/plan/property-type/create-property-type', this.planpropertytype.value).subscribe((res: any) => {
          if (res) {
            this.location.back();
          }
        }, err => {
          this.apiservice.alert('Somthing went wrong', 'error');
        });
      }
    } else {
      this.planpropertytype.markAllAsTouched();
    }
  }

  back() {
    this.location.back();
  }


  getDetails() {
    this.apiservice.get(`admin/plan/property-type/get-property-type/${this.planTypeId}`).subscribe((res: any) => {
      if (res.status === 200) {        
        this.planpropertytype.patchValue(res.body.planPropertyType);
      }
    }, err => { });
  }
  desimalNumberKey(evt: any) {
    const currencyFormat = /^\d*\.?\d*$/;
    if (currencyFormat.test(evt.key) !== true) {
      return false;
    }
    return true;
  }

}
